let viewportHeight = window.innerHeight;
let timelineTriggers = [];
let isAnimationActive = false;

function animateTimeline() {
	const timelineSections = document.querySelectorAll('section.timeline');
	timelineSections.forEach(section => {
		const timelineItems = section.querySelectorAll('.timeline-item');
		timelineItems.forEach(item => {
			const tween = gsap.to(item, {
				scrollTrigger: {
					trigger: item,
					container: section,
					start: `bottom ${viewportHeight * 0.30}px`,
					end: `bottom ${viewportHeight * 0.10}px`,
					// markers: true,
					scrub: true,
				},
				opacity: 0,
				ease: 'easeInOut',
			});
			timelineTriggers.push(tween.scrollTrigger);
		});
	});
	isAnimationActive = true;
}

function resetTimeline() {
	timelineTriggers.forEach(trigger => {
		if (trigger) trigger.kill();
	});
	timelineTriggers = [];
	
	const timelineItems = document.querySelectorAll('section.timeline .timeline-item');
	timelineItems.forEach(item => {
		gsap.set(item, { opacity: 1 });
	});
	isAnimationActive = false;
}

function shouldAnimate() {
	const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
	return window.innerWidth > 768 && !prefersReducedMotion;
}

function handleResize() {
	viewportHeight = window.innerHeight;

	if (shouldAnimate() && !isAnimationActive) {
		animateTimeline();
	} else if (!shouldAnimate() && isAnimationActive) {
		resetTimeline();
	}
}

window.addEventListener('DOMContentLoaded', () => {
	if (shouldAnimate()) {
		animateTimeline();
	}
});

window.matchMedia('(prefers-reduced-motion: reduce)').addEventListener('change', () => {
	if (shouldAnimate() && !isAnimationActive) {
		animateTimeline();
	} else if (!shouldAnimate() && isAnimationActive) {
		resetTimeline();
	}
});

window.addEventListener('resize', handleResize);
